import { combineReducers } from 'redux';
import indexReducer from './indexReducer.js'

const rootReducer = combineReducers({
	indexReducer
})

export default rootReducer